var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio",on:{"click":_vm.onChange}},[(_vm.checked)?_c('img',{attrs:{"src":require("../assets/checked@3x.png")}}):_c('img',{attrs:{"src":require("../assets/unchecked@3x.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }